<template>
  <div class="modal-overlay" @click.self="$emit('close')">
    <div class="modal">
      <button class="close-btn" @click="$emit('close')">×</button>

      <!-- 登录表单 -->
      <div v-if="!isRegister">
        <h2>登录</h2>
        <form @submit.prevent="handleLogin">
          <div class="form-group">
            <label for="email">邮箱</label>
            <input
                id="email"
                v-model="email"
                type="email"
                required
                placeholder="请输入邮箱"
                @input="validateEmail"
            />
          </div>
          <div class="form-group">
            <label for="password">密码</label>
            <el-input
                id="password"
                v-model="password"
                style="width: 400px"
                type="password"
                show-password
                required
                placeholder="请输入密码"
            />
          </div>
          <button type="submit" class="submit-btn">登录</button>
        </form>
        <p class="register-text">
          还没有账号？<a href="#" @click.prevent="switchToRegister">立即注册</a>
        </p>
      </div>

      <!-- 注册表单 -->
      <div v-else>
        <h2>注册</h2>
        <form @submit.prevent="handleRegister">
          <div class="form-group">
            <label for="reg-email">邮箱</label>
            <input
                id="reg-email"
                v-model="regEmail"
                type="email"
                required
                placeholder="请输入邮箱"
                @input="validateEmail"
            />
          </div>

          <div class="form-group">
            <label for="verification-code">验证码</label>
            <div class="custom-verification-code-group">
              <input
                  id="verification-code"
                  v-model="verificationCode"
                  type="text"
                  required
                  :placeholder="isCodeSent ? '验证码已发送！' : '请输入验证码'"
                  style="flex: 1;"
              />
              <button
                type="button"
                class="get-code-btn"
                style="width: 120px;"
                @click="sendVerificationCode">
                发送验证码
              </button>
            </div>
          </div>

          <div class="form-group">
            <label for="reg-password">密码</label>
            <el-input
                id="reg-password"
                v-model="regPassword"
                style="width: 400px"
                type="password"
                show-password
                required
                placeholder="请输入密码"
            />
<!--            <input-->
<!--                id="reg-password"-->
<!--                v-model="regPassword"-->
<!--                type="password"-->
<!--                required-->
<!--                placeholder="请输入密码"-->
<!--            />-->
          </div>
          <button type="submit" class="submit-btn">注册</button>
        </form>
        <p class="register-text">
          已有账号？<a href="#" @click.prevent="switchToLogin">立即登录</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_BASE_URL } from '@/config';
import { ElMessage } from 'element-plus'  // 添加这行导入
import {jwtDecode} from "jwt-decode";
export default {
  emits: ['close', 'login-success'],
  data() {
    return {
      email: '',
      password: '',
      regEmail: '',
      isRegister: false,
      regUsername: '',
      regPassword: '',
      confirmPassword: '',
      verificationCode: '',
      isCodeSent: false,

    }
  },

  methods: {
    validateEmail() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      this.emailValid = emailRegex.test(this.email || this.regEmail);
    },
    handleLogin() {
      if (!this.emailValid) {
        ElMessage.error('请输入有效的邮箱地址')
        return;
      }
      axios.post(`${API_BASE_URL}/login`, {
        email: this.email,
        password: this.password
      })
          .then(response => {
            // 登录成功处理
            const token = response.data.data.token;
            localStorage.setItem('access.halfpanda', token);

            // 获取用户详细信息
            axios.get(`${API_BASE_URL}/user/user-info`, {
              headers: {
                'Authorization': token  // 直接使用token，不加Bearer前缀
              }
            })
                .then(userResponse => {
                  const userData = userResponse.data.data;
                  const username = userData.username || '匿名';
                  localStorage.setItem('username.halfpanda', username);
                  localStorage.setItem('email.halfpanda', userData.email);

                  this.$router.go(0);
                  this.$emit('login-success', username);
                  this.$emit('close');

                })
                .catch(error => {
                  ElMessage.error('登录成功，但获取用户信息失败')
                });
          })
          .catch(error => {
            ElMessage.error('邮箱或密码错误！')
          });
    },
    handleRegister() {
      const email = this.regEmail;
      const password = this.regPassword;
      const code = this.verificationCode;
      console.log('注册参数:', { email, password, code });
      axios
          .post(`${API_BASE_URL}/register`, {
            email: email,
            code: code,
            password: password,
          })
          .then(response => {
            if (response.data.code === 200) {  // 注册成功
              ElMessage.success('注册成功')
              // 保存token等信息
              const storage = localStorage;
              storage.setItem('access.halfpanda', response.data.data.token);
              storage.setItem('email.halfpanda', email);

              this.handleLogin();

              this.$emit('login-success', "匿名");
              this.$emit('close');

            } else if (response.data.code === 409) {  // 邮箱已注册
              ElMessage.error('邮箱已注册')
            }})
    },

    sendVerificationCode() {
      const email = this.regEmail;
      if (!email) {
        ElMessage.error('请输入邮箱地址')
        return;
      }
      this.isCodeSent = true
      axios
          .post(`${API_BASE_URL}/send-code`, {
            email: email,
          }, {
            headers: {
              'Content-Type': 'application/json'
            }
          })
          .then(response => {
            if (response.data.code === 200) {
              this.isCodeSent = true;
            } else {
              ElMessage.error('验证码发送失败!')
            }
          })
          .catch(error => {
            console.error('验证码发送失败:', error);
            console.log('错误详情:', error.response); // 打印完整的响应对象
            console.log('状态码:', error.response?.status); // 打印HTTP状态码
            console.log('错误信息:', error.response?.data); // 打印后端返回的错误信息
            console.log('请求配置:', error.config); // 打印请求配置

          });
    },

    switchToRegister() {
      this.isRegister = true;
      this.isCodeSent = false; // 切换到注册时重置验证码状态
    },
    switchToLogin() {
      this.isRegister = false;
      this.isCodeSent = false;
    },

}}

</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal {
  background-color: white;
  padding: 2rem;
  border-radius: 8px;
  width: auto;
  min-width: 400px;
  max-width: 90%;
  position: relative;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;

/* 新增样式 */
.email-input-group {
  display: flex;
  gap: 10px;
}

.send-code-btn {
  white-space: nowrap;
  padding: 0 12px;
  background-color: #f39c12;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.send-code-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
}

h2 {
  margin-top: 0;
  color: #3498db;
  text-align: center; /* 新增：标题居中 */
}

.form-group {
  margin-bottom: 1rem;
}

label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: bold;
}

input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-sizing: border-box;
}

.submit-btn {
  /* 确保没有禁用属性 */
  pointer-events: auto;
  cursor: pointer;
  width: 100%;
  padding: 0.75rem;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  margin-top: 1rem;
}

.submit-btn:hover {
  background-color: #2980b9;
}

.register-text {
  text-align: center;
  margin-top: 1rem;
}

.register-text a {
  color: #3498db;
  text-decoration: none;
}

.register-text a:hover {
  text-decoration: underline;
}

.custom-verification-code-group {
  display: flex;
  gap: 10px;
}

.custom-verification-code-group input {
  flex: 1;
}

.custom-verification-code-group button {
  width: 120px;
  padding: 0.5rem;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.custom-verification-code-group button:hover {
  background-color: #2980b9;
}
</style>